<template>
  <v-container fluid>
    <search-view :show-search-options="true"
                 :search-options="getSearchKeys"
                 :show-search-date-options="false"
                 :show-search-date="true"
                 :show-add-button="true"
                 @addEvent="addEvent"
                 @initEvent="searchEvent"
                 @searchEvent="searchEvent"
                 @reset="reset"></search-view>

    <v-layout>
      <v-radio-group
          v-model="status"
          row
      >
        <v-radio
            label="全部"
            :value="0"
            :color="Theme.GREEN"
        ></v-radio>
        <v-radio
            label="已付款"
            :value="1"
            :color="Theme.GREEN"
        ></v-radio>
        <v-radio
            label="未付款"
            :value="2"
            :color="Theme.GREEN"
        ></v-radio>
        <v-radio
            label="已退款"
            :value="3"
            :color="Theme.GREEN"
        ></v-radio>
      </v-radio-group>
    </v-layout>

    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <PaymentDetail :visible="paymentView.visible" @cancelEvent="paymentView.visible = false"
    @confirmEvent="reset"/>
  </v-container>
</template>

<script>
import SearchView from "@/components/SearchView";
import TableView from "@/components/TableView";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import PaymentDetail from "@/pages/payment/PaymentDetail.vue";
export default {
  name: "Index",
  components: {
    PaymentDetail,
    TableView, SearchView
  },
  mixins: [common],
  data() {
    return {
      status: 0,
      loading: false,
      searchKey:'',
      searchValue:'',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
      paymentView: {
        visible: false,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
      startDate: '',
      endDate: '',
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters(['getUserInfo']),
    getColumnKeys(){
      return [
        { value:'ok', text:'確認付款' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        // { value:'print', text:'出貨單', color: this.Theme.GREEN, sortable: false , isEvent: true },
        { value:'MerchantTradeNo', text:'金流單號', sortable: true },
        { value:'email', text:'Email', sortable: true , },
        { value:'nickname', text:'暱稱', sortable: true , },
        // { value:'name', text:'姓名', sortable: true , },
        // { value:'cellphone', text:'電話', sortable: true , },
        { value:'amount', text:'金額', sortable: true , },
        { value:'createdDate', text:'建立日期', sortable: true },
        { value:'PaymentDate', text:'付款日期', sortable: true },
        { value:'CustomField1', text:'會員編號', sortable: false },
        { value:'PaymentType', text:'付款方式', sortable: false, options: this.getPaymentTypeList },
        { value:'RtnCode', text:'付款狀態', sortable: true },
        { value:'RtnMsg', text:'付款訊息', sortable: true },
        { value:'vendor', text:'金流商', sortable: true },
        { value:'invoiceType', text:'發票類型', sortable: true, options: this.getInvoiceType },
        { value:'realInvoiceNo', text:'發票號碼', sortable: true },
      ]
    },
    getSearchKeys() {
      return [
        { key: "CustomField1", value: "會員編號" },
        { key: "MerchantTradeNo", value: "金流編號" },
      ];
    },
  },
  methods: {
    ...mapActions(['getPaymentList', 'savePaymentInfo']),
    async loadData(){
      if (!this.isAdmin && !this.isStaff) return;
      try {
        let searchQuery = [];
        if (this.searchKey !== '' && this.searchValue !==''){
          searchQuery.push({ key:this.searchKey , value: this.searchValue });
        }

        this.loading = true;
        const res = await this.getPaymentList({
          pageIndex: this.pagination.page,
          limit: this.pagination.itemsPerPage,
          startDate: `${this.startDate} 00:00:00`,
          endDate: `${this.endDate} 23:59:59`,
          searchQuery: searchQuery,
        });

        if (res.data.statusCode === 0){
          this.list = res.data.data.list;
          this.pagination.totalItems = res.data.data.header.totalCount;

          console.log(`getPaymentList ${JSON.stringify(this.list)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(`getPaymentList error`, e.stack);
      }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page){
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1){
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'ok'){
        this.showAlert({
          title: '提示',
          content: '是否確定此訂單已付款？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.saveEvent(cell.item);
          }
        });
      } else if (cell.key === 'delete'){
        // this.showAlert({
        //   title: '提示',
        //   content: '是否確定要刪除此商品？',
        //   confirmEvent: async () => {
        //     this.hideAlert();
        //     await this.deleteEvent(cell.item);
        //   }
        // });
      } else {
        this.editView.title = cell.key === 'add' ? '新增訂單':'修改訂單'
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
      }

    },
    async saveEvent(payment){
      try {
        const res = await this.savePaymentInfo({
          status: '00',
          orderId: payment.MerchantTradeNo,
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          this.showAlert({title: '提示',
            content: result.message,
            confirmEvent: async () => {
              this.hideAlert();
            }});
          await this.loadData();
        } else {
          this.showAlert({title: '提示',
            content: `儲存失敗 ${result.message}`,
            confirmEvent: async () => {
              this.hideAlert();
            }});
        }

      } catch (e) {
        console.log(`儲存失敗`)
      }
    },
    addEvent(){
      this.paymentView.visible = true;
    },
    searchEvent(info){
      this.startDate = info.startDate;
      this.endDate = info.endDate;
      this.searchKey = info.searchKey;
      this.searchValue = info.searchValue;

      this.loadData();
    },
    reset(){
      this.paymentView.visible = false;
      this.searchValue = '';
      this.loadData();
    },
  }
}
</script>

<style scoped>

</style>
